import { layers } from '@atlaskit/theme/constants';

export const zIndex: {
	searchDialog: 300;
} = {
	searchDialog: layers.dialog(),
};
